const entryContainer = "border-b border-border last:border-b-0";

const entryContent = "flex items-center justify-between px-2 py-1 text-xs";

const slashSeparator = "mx-1 text-muted-foreground";

export { entryContainer, entryContent, slashSeparator };
